import { makeStyles, alpha } from '@material-ui/core/styles';

export const useDeploymentStyles = makeStyles(theme => ({
  deploymentCard: {
    borderRadius: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[8],
    },
  },
  cardHeader: {
    paddingBottom: theme.spacing(1),
  },
  logoContainer: {
    width: 100,
    height: 48,
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.grey[300],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(2),
  },
  statusChip: {
    fontWeight: 600,
    borderRadius: theme.spacing(3),
  },
  changeItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
    '&:last-child': {
      borderBottom: 'none',
    },
  },
  changeLink: {
    textDecoration: 'none',
    color: theme.palette.primary.main,
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  lockSwitch: {
    backgroundColor: alpha(theme.palette.grey[300], 0.5),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
  },
  deploymentButton: {
    width: '15rem',
    height: '2rem',
    marginTop: theme.spacing(1),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    transition: 'all 0.3s ease-in-out',
    '&.unlocked': {
      backgroundColor: theme.palette.success.main,
      color: 'white',
      border: `2px solid ${theme.palette.success.main}`,
      '&:hover': {
        backgroundColor: theme.palette.success.dark,
        border: `2px solid ${theme.palette.success.dark}`,
        transform: 'translateY(-1px)',
        boxShadow: theme.shadows[4],
      },
    },
  },
  statusBadge: {
    '& .MuiBadge-badge': {
      right: -3,
      top: 13,
    },
  },
  metricsSection: {
    backgroundColor: alpha(theme.palette.primary.main, 0.02),
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1.5),
    marginBottom: theme.spacing(2),
  },
  progressBar: {
    height: 6,
    borderRadius: 3,
    backgroundColor: alpha(theme.palette.grey[300], 0.3),
  },
}));
